export const COMPANY_NAME = "Paco Metals Limited";
export const COMPANY_EMAIL = "info@pacometals.com";
export const COMPANY_ADDRESS = {
  street: "4665 Yonge Suite 302",
  city: "Toronto",
  province: "ON",
  postalCode: "M2N 0B4",
};
export const COMPANY_PHONES = ["+1 416 498 5559"];
export const COPYRIGHT_YEAR = 2025;
